
<!--
 * @Description: 学生 详情 考勤信息
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:35:43
-->
<template>
  <div class="list-page pl0 pr0 pt0 pb0">
    <el-container>
      <el-main>
        <el-table :data="dataGrid.data" v-loading="dataGrid.loading" border height="100%">
          <el-table-column label="学期" prop="xqmc" align="center" />
          <el-table-column label="请假次数" align="center">
            <template #default="scope">
              <span>{{scope.row.qjcs}}次</span>
            </template>
          </el-table-column>
          <el-table-column label="旷课次数" align="center">
            <template #default="scope">
              <span>{{scope.row.kkcs}}次</span>
            </template>
          </el-table-column>
          <el-table-column label="早退次数" align="center">
            <template #default="scope">
              <span>{{scope.row.ztcs}}次</span>
            </template>
          </el-table-column>
          <el-table-column label="迟到次数" align="center">
            <template #default="scope">
              <span>{{scope.row.cdcs}}次</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
      </el-footer>
    </el-container>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadList } from '@/api/common.js'
import pagination from '@/components/pagination.vue'

const props = defineProps({
  row: { type: Object, required: false }
})

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xqmc', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/xueshengkaoqin/xueshengkaoqin',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value
  })
}

watch(
  () => props.row,
  () => {
    if (props.row) {
      dataGrid.value.parms.xh = props.row.xh
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
const tcrow = ref({})
const openDetail = ref(false)
</script>
